import { Box } from '@atlaskit/primitives';

import { ChangedValueStyles } from './styles';

type Props = {
  value: string;
};

export const ChartValue = ({ value }: Props) => {
  return <Box xcss={ChangedValueStyles}>{value}</Box>;
};
